var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.043 13.417H7.957C6.64281 13.4185 5.3829 13.9195 4.45363 14.8101C3.52435 15.7006 3.00159 16.908 3 18.1675V23.0003H21V18.1675C20.9984 16.908 20.4756 15.7006 19.5464 14.8101C18.6171 13.9195 17.3572 13.4185 16.043 13.417V13.417Z",
    fill: "#22232C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.5C15.3137 11.5 18 8.92564 18 5.75C18 2.57436 15.3137 0 12 0C8.68629 0 6 2.57436 6 5.75C6 8.92564 8.68629 11.5 12 11.5Z",
    fill: "#22232C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon1);
export default __webpack_public_path__ + "static/media/user_icon_1.267e81d7f0d473f1b249c56d0320d779.svg";
export { ForwardRef as ReactComponent };